import { Avatar, Badge, Tooltip } from 'antd';
import React from 'react';
import UserFilled from '../../../../../../assets/customSVG/inbox/webchat/UserFilled';
import { useSelector } from 'react-redux';
const EndUser = () => {
  const { selectedWebChatConversation, activeEndUsers } = useSelector(
    (state) => state?.inbox,
  );
  const isOnline = activeEndUsers.includes(selectedWebChatConversation?.id);
  //   selectedWebChatConversation?.connection_details?.is_online ||
  //   activeEndUsers.includes(selectedWebChatConversation?.id);
  // console.log({
  //   we_online: selectedWebChatConversation?.connection_details?.is_online,
  //   incEndU: activeEndUsers.includes(selectedWebChatConversation?.id),
  // });

  return (
    <div>
      <Tooltip
        destroyTooltipOnHide
        mouseEnterDelay={0.5}
        placement="bottomLeft"
        color="#727272"
        arrow={false}
        style={{ padding: 0 }}
        title={isOnline ? 'Online' : 'Offline'}
      >
        <Badge
          count={1}
          dot
          color={isOnline ? '#87d068' : 'gray'}
          offset={[-27, 27]}
        >
          <Avatar
            shape="square"
            icon={
              <UserFilled
                width="30px"
                height="30px"
                fill={isOnline ? 'green' : 'gray'}
              />
            }
            style={{ backgroundColor: '#fff' }}
          />
        </Badge>
      </Tooltip>
    </div>
  );
};

export default EndUser;
